import React, { FC } from 'react'

import TruckFast from '@Assets/SVG/TruckFast'
import { TimerVisualizationType, UrgencyTimer } from '@Components/UrgencyTimer'
import { useTranslation } from '@Globals/Translations'

import styles from './ShippingCountdown.module.scss'

type ShippingCountdownDisplayTypes = 'Icon' | 'Text' | 'Countdown'

export interface ShippingCountdownProps {
  display: ShippingCountdownDisplayTypes[]
  id?: string
  visualizationType: TimerVisualizationType
}

export const ShippingCountdown: FC<ShippingCountdownProps> = ({ display, id, visualizationType }) => {
  const { t } = useTranslation()

  const shippingHour = 16
  const danishTimeZone = new Date().toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' })

  const now = new Date(danishTimeZone)

  const today = new Date(danishTimeZone)
  today.setHours(shippingHour, 0, 0, 0)

  const tomorrow = new Date(danishTimeZone)
  tomorrow.setHours(shippingHour, 0, 0, 0)
  tomorrow.setDate(now.getDate() + 1)

  const yesterday = new Date(danishTimeZone)
  yesterday.setHours(shippingHour, 0, 0, 0)
  yesterday.setDate(now.getDate() - 1)

  const shipToday = now.getHours() < shippingHour

  const startAt = shipToday ? yesterday : today
  const endAt = shipToday ? today : tomorrow

  let title = t('shipping:ORDER_SHIPS_TOMORROW')
  let subTitle = t('shipping:DELIVERY_SHIPS_TOMORROW_ORDER_WITHIN')

  if (endAt.getDay() === 6 || endAt.getDay() === 0) {
    title = t('shipping:ORDER_PROCESSED_TOMORROW')
    subTitle = t('shipping:DELIVERY_PROCESSED_TOMORROW_ORDER_WITHIN')
  } else if (shipToday) {
    title = t('shipping:ORDER_SHIPS_TODAY')
    subTitle = t('shipping:DELIVERY_SHIPS_TODAY_ORDER_WITHIN')
  }

  if (!display.includes('Text')) {
    title = ''
    subTitle = ''
  }

  return (
    <div className={styles.shippingCountdownWrapper} id={id}>
      {display.includes('Icon') && <TruckFast />}

      {display.includes('Countdown') && (
        <UrgencyTimer
          endAt={endAt}
          mainTitle={title}
          showCountdown
          showTitle
          startAt={startAt}
          subTitle={subTitle}
          visualizationType={visualizationType}
        />
      )}
    </div>
  )
}
